<template>
  <TooltipPopup>
    <template #trigger>
      <StudioButton
        ref="sortButtonRef"
        :trackingId="trackingId"
        :variant="buttonVariant"
        :class="{
          'tw-border-black': isActive && showBorder,
          'tw-border-transparent': !showBorder
        }"
        size="small"
        @click="handleClick"
      >
        <template #icon>
          <TablerArrowDown v-if="sortOrder === 'asc'" class="tw-h-4 tw-w-4" />
          <TablerArrowUp v-else-if="sortOrder === 'desc'" class="tw-h-4 tw-w-4" />
          <TablerArrowsSort v-else class="tw-h-4 tw-w-4" />
        </template>
      </StudioButton>
    </template>
    <template v-if="showTooltip" #content>Sort</template>
  </TooltipPopup>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

import TablerArrowDown from './Icons/tabler/TablerArrowDown.vue';
import TablerArrowsSort from './Icons/tabler/TablerArrowsSort.vue';
import TablerArrowUp from './Icons/tabler/TablerArrowUp.vue';
import StudioButton, { StudioButtonVariant } from './StudioButton.vue';

import TooltipPopup from '@/studioComponents/TooltipPopup.vue';

export default defineComponent({
  name: 'SortButton',
  components: {
    StudioButton,
    TablerArrowDown,
    TablerArrowUp,
    TablerArrowsSort,
    TooltipPopup
  },
  props: {
    isActive: {
      type: Boolean,
      default: false
    },
    sortOrder: {
      type: String as () => 'asc' | 'desc' | 'none',
      required: true
    },
    trackingId: {
      type: String,
      required: true
    },
    buttonVariant: {
      type: String as () => StudioButtonVariant,
      default: 'outline',
      validator: (value: string) => ['filled', 'outline', 'text', 'warn'].includes(value)
    },
    showTooltip: {
      type: Boolean,
      default: true
    },
    showBorder: {
      type: Boolean,
      default: true
    }
  },
  emits: {
    sortBy: (_order: 'asc' | 'desc') => true
  },
  methods: {
    handleClick() {
      switch (this.sortOrder) {
        case 'asc':
          this.$emit('sortBy', 'desc');
          break;
        case 'desc':
        case 'none':
          this.$emit('sortBy', 'asc');
          break;
      }
    }
  }
});
</script>
